module.exports = __webpack_public_path__ + "img/jacket-right-sub-raglan-classic.2311aa55.png";